/**
 * Personstamm API
 * API for Personstamm Component
 *
 * The version of the OpenAPI document: -
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FieldMetaData } from './fieldMetaData';
import { PsTeilDatumSearchRequestMeta } from './psTeilDatumSearchRequestMeta';
import { PsStrasseFlurnameSearchRequestMeta } from './psStrasseFlurnameSearchRequestMeta';


export interface PersonStammSearchRequestMeta { 
    uid?: string;
    mUid?: FieldMetaData;
    plz?: number;
    mPlz?: FieldMetaData;
    zpvNummer?: string;
    mZpvNummer?: FieldMetaData;
    vorname?: string;
    mVorname?: FieldMetaData;
    sucheMitGrundbuchbezug?: boolean;
    mSucheMitGrundbuchbezug?: FieldMetaData;
    sucheOhneGrundbuchbezug?: boolean;
    mSucheOhneGrundbuchbezug?: FieldMetaData;
    geburtsdatum?: PsTeilDatumSearchRequestMeta;
    mGeburtsdatum?: FieldMetaData;
    searchMode?: PersonStammSearchRequestMeta.SearchModeEnum;
    mSearchMode?: FieldMetaData;
    ahvNummer?: string;
    mAhvNummer?: FieldMetaData;
    ahvVersichertennummer?: string;
    mAhvVersichertennummer?: FieldMetaData;
    ort?: string;
    mOrt?: FieldMetaData;
    name?: string;
    mName?: FieldMetaData;
    strasseFlurname?: PsStrasseFlurnameSearchRequestMeta;
    mStrasseFlurname?: FieldMetaData;
}
export namespace PersonStammSearchRequestMeta {
    export type SearchModeEnum = 'ZPV_SUCHE';
    export const SearchModeEnum = {
        ZPVSUCHE: 'ZPV_SUCHE' as SearchModeEnum
    };
}


